common.View.create('canvas.blocks.custom.impressionSlider.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        let sliderEl = this.element.find('.owl-carousel');

        sliderEl.owlCarousel({
            loop: true,
            margin: 50,
            items: 1.3,
            nav: true,
            dots: sliderEl.data('show-dots'),
            //autoplay: true,
            autoplayTimeout: 6666,
            autoplayHoverPause: true,
            stageClass: 'owl-stage flex',
            center: true,
        });
    }
});
